"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsPim_en_us = void 0;
function componentsPim_en_us() {
    return {
        "components.cartdetails.pleaselogin": "Please login to use your shopping cart",
        "components.cartdetails.ordernow": "order now",
        "components.cartdetails.total": "Total Price",
        "components.cartdetails.noitems": "Your shopping cart is empty"
    };
}
exports.componentsPim_en_us = componentsPim_en_us;
